import React from 'react';
import { Checkbox } from 'antd';

const renderCheckBox = (isReset, onChange, dataComp, value, index) => {
  const [data] = dataComp;
  const isEmpty = data[index] && !data[index].name;
  return (
    <>
      <div><Checkbox disabled={isEmpty || isReset} onChange={e => onChange(data[index], index, e.target.checked * 1)} /></div>
      <div>{value}</div>
    </>  
  )
}

const IncludingBrandColumns = (onChange, dataComp, isReset) => {
  return [
    {
      title: 'Brand 1',
      dataIndex: 'brand',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'brand'),
    },
    {
      title: 'Brand 2',
      dataIndex: 'comp1',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp1'),
    },
    {
      title: 'Brand 3',
      dataIndex: 'comp2',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp2'),
    },
    {
      title: 'Brand 4',
      dataIndex: 'comp3',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp3'),
    },
    {
      title: 'Brand 5',
      dataIndex: 'comp4',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp4'),
    },
    {
      title: 'Brand 6',
      dataIndex: 'comp5',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp5'),
    },
    {
      title: 'Brand 7',
      dataIndex: 'comp6',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp6'),
    },
    {
      title: 'Brand 8',
      dataIndex: 'comp7',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp7'),
    },
    {
      title: 'Brand 9',
      dataIndex: 'comp8',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp8'),
    },
    {
      title: 'Brand 10',
      dataIndex: 'comp9',
      width: '10%',
      render: (value) => renderCheckBox(isReset, onChange, dataComp, value, 'comp9'),
    },
  ];
};

export default IncludingBrandColumns;
